/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";
import { NavItem } from "@shared/components/navigation/nav-item.model";

// @formatter:off
@Component({
    standalone: false,
    selector: "vertical-nav-item",
    templateUrl: "./vertical-nav-item.component.html",
    styleUrls: ["./vertical-nav-item.component.scss"]
})
// @formatter:on
export class VerticalNavItemComponent {

    @Input() navItem: NavItem;
    @Input() subItemStyle: boolean;

}
